/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
import {CommonService} from "../service/common";
declare var $:any;
@Component({
  templateUrl:'./memberGitEdit.html'
})

export class MemberGitEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location,
    private common:CommonService,
    private fileupload:FileUpload
  ){}

  private data:any={
    content:[]
  }

  private id:number = 0;

  private isCreate:boolean=false;

  ngOnInit(): void {
    this.getPath();
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });

    if(this.id!=0){
      this.getData();
    }else {
      this.isCreate = true;
    }
  }



  private getData():void{
    this.HttpService.getData(API.giftMember+"/"+this.id).then(res=>{
      this.data = res.data;
    })
  }

  // 获取图片路径
  private imagePath:string='';

  private getPath():void{
    this.HttpService.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        console.log(res.data)
      })
  }





}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/gift/memberGitEdit.component.ts